import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';

/**
 * A dropdown paired with a primary action button — e.g. the schedule picker
 * plus "Add New Schedule". This exact block is currently duplicated across ~10
 * feature templates (offers, variants, promotions, vouchers, loyalty, events…).
 *
 * Composes <app-select> for the dropdown and emits `(action)` when the button
 * is clicked. All dropdown inputs pass straight through to <app-select>.
 */
@Component({
  selector: 'app-select-with-action',
  templateUrl: './select-with-action.component.html',
  styleUrls: ['./select-with-action.component.scss'],
})
export class SelectWithActionComponent {
  @Input() control!: FormControl;
  @Input() options: any[] = [];
  @Input() valueKey = 'value';
  @Input() labelKey = 'label';
  @Input() emptyLabel = '';
  @Input() emptyValue: any = '';
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() isInvalid = false;
  @Input() inputId = '';
  @Input() testId: string | null = null;
  @Input() panelClass = 'admin-standard-select-panel';
  /** Forwarded to app-select: disable placeholder greying entirely. */
  @Input() greyWhenEmpty = true;
  /** Forwarded to app-select: exact values that render greyed like a placeholder. */
  @Input() greyValues: any[] | null = null;
  /** Forwarded to app-select: `.explanation` hint under the dropdown. */
  @Input() helpText = '';

  @Input() actionLabel = '';
  @Input() actionIcon = 'fa-plus';
  @Input() actionDisabled = false;
  /** Hide the button without losing the dropdown (e.g. role-gated actions). */
  @Input() actionVisible = true;

  @Output() action = new EventEmitter<void>();
  @Output() selectionChange = new EventEmitter<MatSelectChange>();
}
